import React from "react";
import classnames from "classnames";
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon";
import styles from "./MonthSwitcher.module.scss";

const MONTHS = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
];

export interface MonthSwitcherProps {
    /** Месяц в формате «ГГГГ-ММ». */
    month: string;
    onChange: (delta: -1 | 1) => void;
    disablePrev?: boolean;
    disableNext?: boolean;
    className?: string;
}

/** «2026-10» → «Октябрь 2026»; неверная строка — пустая строка. */
export const monthTitle = (month: string): string => {
    const match = /^(\d{4})-(\d{2})$/.exec(month);
    if (!match) {
        return "";
    }

    const name = MONTHS[Number(match[2]) - 1];

    return name ? `${name} ${match[1]}` : "";
};

/**
 * Переключатель месяца «‹ Октябрь 2026 ›»: стрелки отдают сдвиг на месяц (−1 / +1), решение о границах
 * принимает экран (`disablePrev` / `disableNext`). Касание стрелки — не меньше 44×44.
 */
export const MonthSwitcher = ({ month, onChange, disablePrev, disableNext, className }: MonthSwitcherProps) => (
    <div className={classnames(styles.switcher, className)}>
        <button
            type="button"
            className={styles.arrow}
            aria-label="Предыдущий месяц"
            disabled={disablePrev}
            onClick={() => onChange(-1)}
        >
            <GeneralIcon type="general-chevron-left" size={24} />
        </button>
        <span className={styles.title} aria-live="polite">
            {monthTitle(month)}
        </span>
        <button
            type="button"
            className={styles.arrow}
            aria-label="Следующий месяц"
            disabled={disableNext}
            onClick={() => onChange(1)}
        >
            <GeneralIcon type="general-chevron-right" size={24} />
        </button>
    </div>
);
